import {AuditTrail} from "../types";

export const REDUX_AUDIT_TRAIL = {
    FetchAll: "AUDIT_TRAIL_FETCH_ALL",
}

export interface IAuditTrail {
    data: AuditTrail[]
}

const initialState = {
    data: []
}

export default function reducer(state = initialState, action: any) {
    switch (action.type) {
        case REDUX_AUDIT_TRAIL.FetchAll: {
            return {...state, data: action.payload}
        }

        default: {
            return state
        }
    }
}
